/* ============
 * SubscribeList Index
 * ============
 *
 * This page shows the list of SubscribeList.
 */

import { mapGetters, mapMutations } from 'vuex';
import subscriberListService from './../../../../services/subscriberList';
import SearchMixin from './../../../../mixins/search';
import DateMixin from './../../../../mixins/date';

export default {
  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      subscriberList: 'paginatedSubscriberList'
    }),
  },

  mounted() {
    this.setInnerSidebar([
      {
        title: this.$t('layouts.sidebar.newsletter'),
        options: [
          {
            title: this.$t('layouts.sidebar.all'),
            route: {
              name: 'campaigns.index',
            },
          },
        ],
        button: {
          title: this.$t('button.addCampaign'),
          route: {
            name: 'campaigns.create',
          },
        },
      },
      {
        title: this.$t('layouts.sidebar.subscriberList'),
        options: [
          {
            title: this.$t('layouts.sidebar.all'),
            route: {
              name: 'subscriberList.index',
            },
          },
        ],
        button: {
          title: this.$t('button.addSubscriberList'),
          route: {
            name: 'subscriberList.create',
          },
        },
      },
    ]);
    this.all(1, 15);
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    /**
     * Fetches paginated subscriberList.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed on a page.
     */
    all(page, limit) {
      this.loading = true;
      subscriberListService.items(page, limit)
      .then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },

    /**
     * Go to edit view for Campaign.
     *
     * @param  {Object} subscriberList The Campaign object.
     */
    edit(id) {
      this.$router.push({
        name: 'subscriberList.edit',
        params: { id: id },
      });
    },
  },

  mixins: [
    SearchMixin,
    DateMixin,
  ],

  components: {
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VSelect: require('./../../../../components/form/select/select.vue'),
    VCard: require('./../../../../components/card/card.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/subscriberList/index/index.js